<template>
  <section>
    <form class="form form__warehouses--add-products" autocomplete="off" @submit.prevent="perform">
      <b-field label="Fornitore *">
        <b-select placeholder="Seleziona il fornitore"
                  icon="store"
                  v-model="chosenSupplierId">
          <option v-for="supplier in suppliers"
                  :key="supplier.id"
                  :value="supplier.id"> {{ supplier['company-name'] }}
          </option>
        </b-select>
      </b-field>
      <div class="field is-grouped">
        <suggest
          :disabled="disableSku"
          label="Codice"
          :model="product.sku"
          placeholder="0303AB.4040"
          prop="sku"
          :list="inventory"
          @choosedAsObject="skuSuggestCallback"></suggest>
        <suggest
          :disabled="disableDescription"
          :expanded="true"
          label="Descrizione"
          :model="product.description"
          placeholder="GUARNIZIONE PER RACCORDO DIN DN 80"
          prop="description"
          :list="inventory"
          @choosedAsObject="descriptionSuggestCallback"></suggest>
        <div class="control is-clearfix">
          <label class="label">Quantità</label>
          <input readonly v-model="product.quantity" step="0.01" min="0.01" max="999999.99"
                 type="number" class="input" placeholder="10.00"/>
        </div>
        <div class="control is-clearfix">
          <label class="label">Prezzo (€)</label>
          <input v-model="product.price" step="0.01" min="0.01" max="999999.99"
                 type="number" class="input" placeholder="10.00"/>
        </div>
        <div class="control">
          <div class="label is-unselectable">&nbsp;</div>
          <button class="button is-primary is-normal" @click.prevent="add()" type="button">
            <b-icon icon="plus"></b-icon>
          </button>
        </div>
      </div>

      <table-component v-if="products.length" :show-filter="false" :data="products"
                       :show-caption="false" sort-by="description" sort-order="asc">
        <table-column label="Codice" show="sku"></table-column>
        <table-column label="Descrizione" show="description"></table-column>
        <table-column label="Quantità (Kg/l)" show="quantity"></table-column>
        <table-column label="Prezzo (€)" show="price">
          <template slot-scope="row">
            <b-input v-model="row.price" step="0.01" min="0.01" max="9999.99" type="number"></b-input>
          </template>
        </table-column>
        <table-column label="Nota" show="note">
          <template slot-scope="row">
            <b-input v-model="row.note" type="text" maxlength="64" icon="sticky-note"></b-input>
          </template>
        </table-column>
        <table-column label="Azioni" :sortable="false">
          <template slot-scope="row">
            <a title="Elimina"
               @click.prevent="remove(row.sku)">
              <b-icon type="is-primary" icon="trash"></b-icon>
            </a>
          </template>
        </table-column>
      </table-component>

      <button class="button is-primary" :disabled="products.length === 0" type="submit">Conferma</button>
    </form>
  </section>
</template>

<script>
  import {api, utils} from '../../../helpers'
  import Suggest from '../../actions/Suggest'

  export default {
    name: 'AddPurchaseRequestComponent',
    components: {Suggest},
    props: {
      role: {
        type: String,
        required: true
      },
      inventory: {
        type: Array,
        required: true
      },
      warehouseId: {
        type: Number,
        required: true
      },
      ddtCode: {
        required: true,
        validator: prop => typeof prop === 'string' || prop === null
      },
      ddtType: {
        required: true,
        validator: prop => typeof prop === 'string' || prop === null
      },
      ddtDate: {
        required: true,
        validator: prop => typeof prop === 'object'
      }
    },
    data () {
      return {
        products: [],
        product: {
          id: null,
          sku: null,
          description: null,
          quantity: null,
          price: null,
          note: ''
        },
        disableSku: false,
        disableDescription: false,
        suppliers: [],
        chosenSupplierId: ''
      }
    },
    created () {
      const modal = this.$loading.open()
      if (this.warehouseId) {
        api.getWarehouse(this.warehouseId)
          .then((warehouse) => {
            api.getSuppliers(warehouse['estate-id'])
              .then(suppliers => { this.suppliers = suppliers })
          })
          .catch(errors => utils.errors(errors))
      }
      modal.close()
    },
    methods: {
      skuSuggestCallback (item) {
        const found = this.inventory.find(elem => {
          return elem.sku === item.sku && elem.quantity === item.quantity
        })
        if (found) {
          this.product.id = item.id
          this.product.sku = item.sku
          this.product.quantity = item.quantity
          this.product.description = item.description
          this.disableDescription = true
        } else {
          this.product.id = 0
          this.product.sku = item.sku
          this.product.quantity = 0
          this.product.description = this.product.description || ''
          this.disableDescription = false
        }
      },
      descriptionSuggestCallback (item) {
        const found = this.inventory.find(elem => {
          return elem.sku === item.sku && elem.quantity === item.quantity
        })
        if (found) {
          this.product.id = item.id
          this.product.sku = item.sku
          this.product.quantity = item.quantity
          this.product.description = item.description
          this.disableSku = true
        } else {
          this.product.id = 0
          this.product.sku = this.product.sku || ''
          this.product.quantity = 0
          this.product.description = item.description
          this.disableSku = false
        }
      },
      add () {
        if (utils.objectByKey(this.products, 'sku', this.product.sku) || false) {
          utils.errors(['Il prodotto selezionato è già stato aggiunto.'])
          return false
        }

        if (!this.product.sku || this.product.sku.length === 0) {
          utils.errors(['Inserire il codice del prodotto.'])
          return false
        }

        if (!this.product.description || this.product.description.length === 0) {
          utils.errors(['Inserire la descrizione del prodotto.'])
          return false
        }

        if (!this.product.quantity || this.product.quantity === 0) {
          utils.errors(['Inserire la quantità del prodotto.'])
          return false
        }

        if (!this.product.price || this.product.price === 0) {
          utils.errors(['Inserire il prezzo del prodotto.'])
          return false
        }

        this.disableDescription = false
        this.disableSku = false

        this.products.push(utils.copy(this.product))
        this.product = utils.reset(this.product)
      },
      remove (sku) {
        this.products.splice(utils.indexOfObject(this.products, 'sku', sku), 1)
      },
      perform () {
        if (!this.chosenSupplierId) {
          utils.errors(['Selezionare il fornitore.'])
          return false
        }
        if (!this.ddtCode) {
          utils.errors(['Inserire il codice DDT.'])
          return false
        }
        if (!this.ddtDate) {
          utils.errors(['Inserire la data del DDT.'])
          return false
        }
        if (!this.ddtType) {
          utils.errors(['Inserire la tipologia del DDT.'])
          return false
        }

        utils.confirm('Aggiungere i prodotti in magazzino?', () => {
          const modal = this.$loading.open()
          let ddtDate = utils.formatDateToYmd(this.ddtDate, '-')
          api.addProductsToWarehouse(this.warehouseId, this.chosenSupplierId, this.ddtCode, ddtDate, this.products, true)
            .then(() => {
              utils.success('Prodotti aggiunti con successo.', modal)
              this.$router.replace({name: `Warehouses`, params: {estateId: this.estateId}})
            }).catch(errors => utils.errors(errors, modal))
        })
      }
    },
    watch: {
      'product.sku': function (newer, older) {
        if (newer === '') {
          this.disableDescription = false
        }
      },
      'product.description': function (newer, older) {
        if (newer === '') {
          this.disableSku = false
        }
      },
      'product.quantity': function (newer, older) {
        this.product.quantity = newer === 0 ? null : parseFloat(newer)
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-component {
    margin-bottom: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/warehouses/AddPurchaseRequestComponent.vue